import { DatePipe } from '@angular/common';
import { Component, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { PatientScreenTypeEnum } from 'src/app/enums/patient-screen-enum';
import { GenderList } from 'src/app/_constants/dropDown.constant';
import { FilterParams, Patient } from 'src/app/_models/patient.model';
import { CityService } from 'src/app/_services/city.service';
import { PatientService } from 'src/app/_services/patient.service';
import * as XLSX from 'xlsx';
import { TableColumn } from '@swimlane/ngx-datatable';
import { ISmartTablePagination } from 'src/app/_interfaces/smart-table/i-pagination';
import { ISmartTableMessage } from 'src/app/_interfaces/smart-table/i-message';
import { IExcelPatient } from 'src/app/_interfaces/patients/i-excel-patient';

@Component({
  selector: 'app-patients-list',
  templateUrl: './patients-list.component.html',
  styleUrls: ['./patients-list.component.scss'],
})
export class PatientsListComponent implements OnInit {
  searchParams: FilterParams = {
    currentPage: 1,
    pageSize: 10,
  };
  patientList: Patient[];
  genderList = GenderList;
  osList = [
    { id: 0, label: 'All' },
    { id: 1, label: 'IOS' },
    { id: 2, label: 'Android' },
  ];
  pageSizeList = [10, 20, 50, 100];
  loading = false;
  emptyArray = true;
  totalPages = 2;
  cityList = [];
  columns: TableColumn[];
  totalItems: number;
  @ViewChild('nationalIdPassportIdRef') public nationalIdPassportIdRef: TemplateRef<any>;
  messages: ISmartTableMessage = {
    emptyMessage: 'Hmm, There are no Patients for this search criteria 🥺',
    totalMessage: 'total',
    selectedMessage: ''
  }

  constructor(
    private patientService: PatientService,
    private spinner: NgxSpinnerService,
    private cityService: CityService,
    private router : Router,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.getAllPatients();
    this.patientService.setPatientScreenType(PatientScreenTypeEnum.LimitlesscarePatients);
  }

  getAllPatients() {
    this.loading = true;
    this.spinner.show();
    this.patientService
      .getFilteredPatients(this.searchParams)
      .subscribe((res) => {
        this.patientList = res.data.items;
        this.loading = false;
        if(!this.cityList.length){
          this.cityService.getAllCities().subscribe((res) => {
            this.cityList = res;
            this.patientList.map((patient) => {
              patient.cityName = this.cityList.find(
                (city) => city.id == patient.cityId
              )?.enName;
            });
          });
        }
        else{
          this.patientList.map(patient => {
            patient.cityName = this.cityList.find(
              (city) => city.id == patient.cityId
            )?.enName;
          });
        }
        this.initalizePatientsColumns();
        this.totalItems = res.data.pagination.totalItems;
        this.totalPages = res.data.pagination.totalPages;
        this.searchParams.currentPage = res.data.pagination.currentPage;
        this.spinner.hide();
      });
  }

  onChangePage(pageDetails: ISmartTablePagination){
    this.searchParams.currentPage = pageDetails.offset + 1;
    this.getAllPatients();
  }

  resetSearchParams() {
    Object.keys(this.searchParams).forEach((key) => {
      if (key == 'searchTerm') {
        delete this.searchParams[key];
      }
    });
  }

  getAllCities() {
    this.cityService.getAllCities().subscribe((res) => {
      this.cityList = res;
    });
  }

  onSearchPatients(searchValue: string) {
    this.searchParams.currentPage = 1;
    if (searchValue.length > 0) {
      this.searchParams.searchTerm = searchValue;
    }
    else{
      this.resetSearchParams();
    }
    this.getAllPatients();
  }

  initalizePatientsColumns(){
    this.columns = [
      {prop: 'fullName', name: 'Patient Name'},
      {prop: 'phone', name: 'Mobile Number'},
      {prop: 'nationalIdpassportId', name: 'National Id / Passport Id',
        cellTemplate: this.nationalIdPassportIdRef},
      {prop: 'cityName', name: 'City'},
      {prop: 'patientType', name: 'Patient Type'},
    ]
  }

  routeToPatientDetails(patient){
    this.router.navigate(['/patient-details/', patient.selected[0].id]);
  }

  exportToExcel(){
    let data: IExcelPatient[] = [];
    this.patientService.getExportToExcelPatients().subscribe((res=>{

      data = res.data;
      const header: string[][] = [[]];
      const ws = XLSX.utils.json_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.sheet_add_aoa(ws, header);

      //Starting in the second row to avoid overriding and skipping headers
      XLSX.utils.sheet_add_json(ws, data, { origin: 'A2', skipHeader: true });
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      XLSX.writeFile(wb, `Patients - ${Date.now()}.xlsx`);

    }))


  }
}
